angular
    .module('app')
    .component('contractsAdd', {
        templateUrl: '/templates/pages/contracts/contractsAdd/contractsAdd.html',
        controller: 'ContractsAddController',
        controllerAs: 'vm',
    });